import { render, staticRenderFns } from "./roadStudPage.vue?vue&type=template&id=45f347cc"
import script from "./roadStudPage.vue?vue&type=script&lang=js"
export * from "./roadStudPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports